import { DaymapQuery as u } from "../daymapQuery.js";
var d;
((l) => {
  ((s) => {
    s.All = "All", s.ThisYear = "ThisYear", s.Current = "Current", s.Course = "Course", s.Dashboard = "Dashboard";
  })(l.AssessmentTaskListDateRange || (l.AssessmentTaskListDateRange = {}));
  class c extends u {
    constructor(e) {
      super(
        ["tasksForStudent", e.studentId, e.classCode, e.dateRange, e.allPublished, e.courseId, e.loadPreview],
        e,
        `/lms/api/assessment/studenttasklist?studentId=${e.studentId}&classCode=${e.classCode ? e.classCode : ""}&dateRange=${e.dateRange}&allPublished=${e.allPublished}${e.courseId ? `&courseId=${e.courseId}` : ""}${e.loadPreview ? `&loadPreview=${e.loadPreview}` : ""}`,
        null,
        { stale: 1e3 * 60 }
        // 1 minutes
      );
    }
  }
  l.TasksForStudent = c;
  class n extends u {
    constructor(e) {
      super(
        ["gradebookResults", e.studentId, e.classCode, e.dateRange, e.allPublished, e.courseId],
        e,
        `/lms/api/assessment/gradebookresults?studentId=${e.studentId}&classCode=${e.classCode}&dateRange=${e.dateRange}&allPublished=${e.allPublished}${e.courseId ? `&courseId=${e.courseId}` : ""}`,
        null,
        { stale: 1e3 * 60 }
        // 1 minute
      );
    }
  }
  l.GradbookResults = n;
  class r extends u {
    constructor({ studentId: e, taskId: t, enabled: a = !0 }) {
      super(
        ["gettaskandoutcomes", e, t],
        { studentId: e, taskId: t },
        `/lms/api/assessment/gettaskandoutcomes?studentId=${e}&taskId=${t}`,
        null,
        { stale: 1e3 * 60, enabled: a }
        // 1 minutes
      );
    }
  }
  l.GetTaskAndOutcomes = r;
  class o extends u {
    constructor({ studentId: e, taskId: t, enabled: a = !0 }) {
      super(
        ["studentresults", e, t],
        { studentId: e, taskId: t },
        `/lms/api/assessment/studentresults?studentId=${e}&taskId=${t}`,
        null,
        { stale: 1e3 * 60, enabled: a }
        // 1 minutes
      );
    }
  }
  l.StudentResults = o;
  class $ extends u {
    constructor({ studentId: e, taskId: t, enabled: a = !0 }) {
      super(
        ["attachments", e, t],
        { studentId: e, taskId: t },
        `/lms/api/assessment/attachments?studentId=${e}&taskId=${t}`,
        null,
        { stale: 1e3 * 60, enabled: a }
        // 1 minutes
      );
    }
  }
  l.TaskAttachments = $;
})(d || (d = {}));
export {
  d as assessment
};
//# sourceMappingURL=index.js.map
